import { VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

import { FixedIncomeAssetsQueryData } from '../../../../../../../store/customerAssetDetail/selector';
import { FixedIncomeSecondaryInfo } from '../SecondaryInfo';
import { YieldComparisonPanel } from '../YieldComparisonPanel';

export interface FixedIncomeDetailsProps {
  product: Utils.ArrayElement<NonNullable<FixedIncomeAssetsQueryData>>;
}

export const FixedIncomeDetails: React.FC<FixedIncomeDetailsProps> = ({ product }) => {
  return (
    <VStack w="full">
      <FixedIncomeSecondaryInfo product={product} />
      <YieldComparisonPanel product={product} />
    </VStack>
  );
};
